module.exports = __webpack_public_path__ + "img/9788991813922.bca5ae07.jpg";